import React, { useEffect, useState } from "react";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { ArrowLeftIcon, ArrowRightIcon } from "../../assets/icons";
import { locationFilterOptions } from "../../constants/propertyDetail.constants";
import NearbyLocationCard from "./NearbyLocationCard";

const NearbyLocations = ({ locations }) => {
  const [nearbyLocations, setNearbyLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(
    locationFilterOptions[0]
  );

  const handleLocationChange = (value) => {
    setSelectedLocation(value);

    if (value.type === locationFilterOptions[0].type) {
      setNearbyLocations(locations); // Show all locations when type is all
    } else {
      const filteredLocations = locations.filter((l) => l.type === value.type);
      setNearbyLocations(filteredLocations); // Filter based on selected type
    }
  };

  const getIconByLocationType = (type) => {
    return locationFilterOptions.find((f) => f.type === type)?.icon;
  };

  useEffect(() => {
    if (locations) {
      setNearbyLocations(locations);
    }
    // eslint-disable-next-line
  }, [locations]);

  return (
    <div className="nearby-locations-wrapper">
      <h2>Nearby Locations</h2>
      <div className="nearby-locations-flexbox">
        {locationFilterOptions.map((option) => (
          <div
            key={option.id}
            className={`nearby-locations-item ${
              selectedLocation?.id === option.id ? "active" : ""
            }`}
            onClick={() => handleLocationChange(option)}
          >
            <img
              className="nearby-locations-icon"
              src={option.icon}
              alt={option.name}
            />
            <div
              className="nearby-locations-text text-ellipsis"
            >
              {option.name}
            </div>
          </div>
        ))}
      </div>
      {/* Slider  */}
      <div className="nearby-location-slider">
        <Swiper
          slidesPerView={1}
          spaceBetween={20}
          grabCursor={true}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
            clickable: true,
          }}
          breakpoints={{
            320: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            480: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            576: {
              slidesPerView: 2.5,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 3.5,
              spaceBetween: 20,
            },
            992: {
              slidesPerView: 5,
              spaceBetween: 10,
            },
            1200: {
              slidesPerView: 6,
              spaceBetween: 20,
            },
            1400: {
              slidesPerView: 7,
              spaceBetween: 20,
            },
          }}
          modules={[Navigation]}
          className="swiper-container"
        >
          {nearbyLocations?.length > 0 ? (
            nearbyLocations.map(({ id, name, distance, type }) => (
              <SwiperSlide key={id}>
                <NearbyLocationCard
                  name={name}
                  distance={distance}
                  icon={getIconByLocationType(type)}
                />
              </SwiperSlide>
            ))
          ) : (
            <SwiperSlide className="nearby-location-not-found">
              <div className="nearby-location-card">
                Nearby Locations Not Found
              </div>
            </SwiperSlide>
          )}
        </Swiper>
        <div className="slider-controler">
          <div className="swiper-button-prev slider-arrow">
            <img src={ArrowLeftIcon} alt="arrow left" />
          </div>
          <div className="swiper-button-next slider-arrow">
            <img src={ArrowRightIcon} alt="arrow right" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NearbyLocations;
